import React, { useEffect, useMemo, useState } from 'react'
import IPInput from '../../../../../components/IPInput'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import Table from '../../../../../components/Table'
import Swal from 'sweetalert2'
import { GetDealerSubTypeListApi } from '../services/getDealersApi'
import IPButton from '../../../../../components/IPButton'
import moment from 'moment'
import { IDealerSubTypeRequestModel, IDealerSubTypeResponseModel } from '../models/model'
import IPSelectBox from '../../../../../components/IPSelectBox/IPSelectBoxMenu'
import { ISelectOption } from '../../../HomeAndSiteOperation/BulkAdding/components/BulkAdding'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'

interface IDealerListState {
  dealercode: string
  dealerName: string
  subTypeCode: string
  selectedCompany?: ISelectOption
  companies: ISelectOption[]
}

function Index(props: BaseComponentWithContextProps) {

  const getInitialState = (): IDealerListState => {
    return {
      dealercode: '',
      dealerName: '',
      subTypeCode: '',
      companies: [],
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IDealerListState>(intialState)

  const [dealerList, setDealerList] = useState<IDealerSubTypeResponseModel[]>([])

  const getDealerList = () => {
    props.showLoading();

    const dealersApi: GetDealerSubTypeListApi = new GetDealerSubTypeListApi({})

    const req: IDealerSubTypeRequestModel = {
      DealerCode: state.dealercode,
      DealerName: state.dealerName,
      Company: state.selectedCompany?.value?.toString() || '',
      SubTypeCode: state.subTypeCode,
    }
    try {
      dealersApi.getDealers(req).then(res => {
        if (res) {
          setDealerList(res)
        } else {
          setDealerList([])
        }
        props.hideLoading();
      }).catch(err => {
        props.hideLoading();
        Swal.fire({
          icon: 'error',
          title: err?.description || 'Bayi listesi alınırken bir hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
    } catch (err: any) {
      props.hideLoading();
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Bayi listesi alınırken bir hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
    getCompanies()
  }, [])

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Code.toString(),
      }))
      setState({ companies: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }


  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'order',
      },
      {
        Header: 'Şirket',
        accessor: 'Company',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'SAPCode',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'TheName',
      },
      {
        Header: 'Alt Tip Kodu',
        accessor: 'SubTypeCode',
      },
      {
        Header: 'Alt Tip Açıklama',
        accessor: 'SubTypeName',
      },
      {
        Header: () => <span style={{ whiteSpace: 'nowrap' }}>Oluşturulma Tarihi</span>,
        accessor: 'CreatedDate',
        minWidth: 160,
        width: 160,
      },
    ],
    []
  )


  const tableData = useMemo(
    () =>
      dealerList.map((item, index) => {
        const data = {
          order: index + 1,
          SAPCode: item.DealerCode,
          TheName: item.DealerName,
          Company: state.companies.find((c) => c.value === item.Company)?.label || item.Company,
          SubTypeCode: item.SubTypeCode,
          SubTypeName: item.SubTypeName,
          CreatedDate: moment(item.CreatedDate).format("DD.MM.YYYY"),
        }
        return data
      }),
    [dealerList]
  )

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center mb-2'>
            <div className='col-lg-10 d-flex align-items-center'>
              <h4>Bayi Alt Tip Listesi (B2B)</h4>
            </div>
          </div>
          <div className='row ml-2 mr-2'>
            <div className='col-lg-2'>
              <label htmlFor='trackNo' className='form-label'>
                Cari Kodu / Vergi Numarası
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='dealerCode'
                placeholder='Cari Kodu / Vergi Numarası'
                onChange={(e) => setState({ dealercode: String(e.target.value).trim() })}
                value={state.dealercode}
              />
            </div>
            <div className='col-lg-3'>
              <label htmlFor='trackNo' className='form-label'>
                Cari Adı
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='dealerName'
                placeholder='Cari Adı'
                onChange={(e) => setState({ dealerName: String(e.target.value).trim() })}
                value={state.dealerName}
              />
            </div>
            <div className='col-lg-3'>
              <label htmlFor='trackNo' className='form-label'>
                Alt Tip Kodu
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='subTypeCode'
                placeholder='Alt Tip Kodu'
                onChange={(e) => setState({ subTypeCode: String(e.target.value).trim() })}
                value={state.subTypeCode}
              />
            </div>
            <div className='col-lg-2'>
              <label htmlFor='trackNo' className='form-label'>
                Şirket
              </label>
              <IPSelectBox
                isClearable
                id="Şirket"
                name="Şirket"
                placeholder="Şirket"
                options={state.companies}
                value={state.selectedCompany}
                onChangeSingle={(option) => setState({ selectedCompany: option })}
              />
            </div>
            <div className='col-lg-1 mt-5'>
              <IPButton text={'Göster'}
                type='button' className='btn btn-primary'
                onClick={() => getDealerList()} />
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <Table columns={tableColumns} data={tableData} currentPage={0} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(Index)
